import React, { forwardRef } from 'react'

import { BaseLink, type BaseLinkProps } from './BaseLink'

export interface TextLinkProps
  extends BaseLinkProps,
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className' | 'color'> {
  children: React.ReactNode;
  disabled?: boolean;
}

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(({
  children,
  disabled,
  onClick,
  ...props
}, forwardedRef) => {
  return (
    <BaseLink {...props}>
      <a
        aria-disabled={disabled}
        href={disabled ? undefined : props.href}
        onClick={disabled
          ? (event) => {
              event.preventDefault()
            }
          : onClick}
        ref={forwardedRef}
        tabIndex={disabled ? -1 : undefined}
      >
        {children}
      </a>
    </BaseLink>
  )
})
